import Request from './request';
import type { PostHelperConfig, SaveContentForLaterParams } from './types';

export default class ApiService {
  static getAdditionalTileData(obfuscatedId: string): Promise<any> {
    const url = `/api/content_blocks/tile_container/${obfuscatedId}/additional_tile_data/`;

    return Request.getHelper(url);
  }

  static saveContentForLater(params: SaveContentForLaterParams, enablePostAuth: boolean = true): Promise<any> {
    const url = `/settings/saved-content/`;

    // Only use post-auth config for save operations (is_active=true) when enablePostAuth is true
    const usePostAuth = enablePostAuth && params.is_active === true;
    
    let postConfig: PostHelperConfig = {};
    if (usePostAuth) {
      const contentId = params.content_type === 'published_course' 
        ? params.published_course_id 
        : params.published_path_id;
      
      if (contentId) {
        postConfig = {
          saveForLater: {
            contentType: params.content_type,
            contentId: contentId,
            isActive: params.is_active
          }
        };
      }
    }

    return Request.postHelperWithAuthRedirect(url, params, postConfig);
  }

  static saveContentForLaterWithDomain(params: object, contentDomainId?: string): Promise<any> {

    const baseUrl = `/settings/saved-content/`;
    const url = contentDomainId ? `${baseUrl}?d=${contentDomainId}` : baseUrl;

    return Request.postHelper(url, params);
  }
}
